import { useEffect, useState } from "react";
import { api } from "../../../Api/ApiService";
import { Menus } from "../../../components/Menu/idex";
import { AxiosError } from "axios";
import Alert from "sweetalert2";
import { Tables } from "../../../components/tables";
import {
  StyleHStack,
  StyledFormControl,
  StyledFormControlMarge,
} from "./styles";
import dayjs from "dayjs";
import { getUser } from "../../../context/token";
import {
  Button,
  FormControl,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Text,
  Image,
  HStack,
  Card,
  CardBody,
  FormLabel,
  Switch,
  useToast,
} from "@chakra-ui/react";
import { convertToBase64 } from "../../../utils/bse64Foto";

type Entrevista = {
  id_entrevista: string;
  data: string;
  hora: string;
  local: string;
  ausencia_entrevista: boolean;
  tutor?: string;
};

type Animal = {
  nome: string;
  tipo?: string;
  foto: {
    data: Buffer;
  };
  raca: string;
  sexo: string;
};

type AnimalFoto = {
  nome: string;
  tipo?: string;
  foto: string;
  raca: string;
  sexo: string;
};

type Tutor = {
  nome: string;
  cpf: string;
  email: string;
  rua: string;
  numero: number;
  bairro: string;
  cidade: string;
  uf: string;
  whastapp: string;
  instagram: string;
  quantidade_animais: number;
  tem_experiencia: boolean;
  tem_outro_animal: boolean;
  tipo_animais: [];
};

interface IInforAgendamentos {
  entrevista: Entrevista;
  tutor: Tutor;
  animal: Animal;
}

interface IInforTable {
  col1: string;
  col2: string;
  col3: string;
  col4?: string;
  col5?: boolean;
  id?: string;
}

const Agendamentos = () => {
  const [inforagendamentos, setInforagendamentos] = useState<
    IInforAgendamentos[]
  >([]);
  const [agendamentoResult, setAgendamentoResult] = useState<IInforTable[]>([]);
  const [agendamentoTutorResult, setAgendamentotutorResult] = useState<
    IInforTable[]
  >([]);
  const { role, email } = getUser();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [inforTutor, setInforTutor] = useState<Tutor[]>([]);
  const [inforAnimal, setInforAnimal] = useState<AnimalFoto[]>([]);
  const [idAgendamento, setIdAgendamento] = useState("");
  const [statusAgendamento, setStatusAgendamento] = useState(false);
  const toast = useToast();

  async function getAgendamentos() {
    try {
      const resul = await api.get(
        `/agendamentos?token=${process.env.REACT_APP_TOKEN_API}`
      );

      const entrevista_tutor = resul.data.map((item: IInforAgendamentos) => ({
        entrevista: item.entrevista,
        tutor: item.tutor,
        animal: item.animal,
      }));

      // const tutor = resul.data.map((item: IInforAgendamentos) => item.tutor);

      setInforagendamentos(entrevista_tutor);

      let resAgendamento: IInforTable[] = [];
      entrevista_tutor.map((item: any, index: any) => {
        resAgendamento.push({
          col1: item.entrevista.tutor,
          col2: item.entrevista.data,
          col3: item.entrevista.hora,
          col4: item.entrevista.local,
          col5: item.entrevista.ausencia_entrevista,
          id: index,
        });
      });

      setAgendamentoResult(resAgendamento);
      const filterInfor = await resul.data.filter(
        (item: any) => item.tutor.email === email
      );

      let resTutor: IInforTable[] = [];
      filterInfor.map((item: any, index: any) => [
        resTutor.push({
          col1: dayjs(item.entrevista.data).format("DD/MM/YYYY"),
          col2: item.entrevista.hora,
          col3: item.entrevista.local,
          id: index,
        }),
      ]);

      setAgendamentotutorResult(resTutor);
    } catch (error: AxiosError | any) {
      console.log(error);
    }
  }

  async function updatebtnAgendamentos(ausencia_entrevista: boolean, id_agendamento: string) {
    try {
      Alert.fire({
        toast: true,
        icon: "question",
        text: "O tutor compareceu à entrevista?",
        showCancelButton: true,
        cancelButtonText: "Não",
        cancelButtonColor: "red",
        confirmButtonText: "Sim",
        confirmButtonColor: "#044549",
      }).then(async(result)=>{
        if(result.isConfirmed){
          const res = await api.patch(`/agendamentos/${id_agendamento}?token=${process.env.REACT_APP_TOKEN_API}`,{
            ausencia_entrevista: ausencia_entrevista,
          })
          
          Alert.fire({
            toast: true,
            icon: "success",
            text: res.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#3f3d56",
          }).then(() => {
            window.location.reload();
          });
        }
      })
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function openModal(index: any) {
    onOpen();
    let restutor: Tutor[] = [];
    restutor.push({
      nome: inforagendamentos[index].tutor.nome,
      cpf: inforagendamentos[index].tutor.cpf,
      email: inforagendamentos[index].tutor.email,
      rua: inforagendamentos[index].tutor.rua,
      numero: inforagendamentos[index].tutor.numero,
      bairro: inforagendamentos[index].tutor.bairro,
      cidade: inforagendamentos[index].tutor.cidade,
      uf: inforagendamentos[index].tutor.uf,
      whastapp: inforagendamentos[index].tutor.whastapp,
      instagram: inforagendamentos[index].tutor.instagram,
      quantidade_animais: inforagendamentos[index].tutor.quantidade_animais,
      tem_experiencia: inforagendamentos[index].tutor.tem_experiencia,
      tem_outro_animal: inforagendamentos[index].tutor.tem_outro_animal,
      tipo_animais: inforagendamentos[index].tutor.tipo_animais,
    });
    setStatusAgendamento(
      inforagendamentos[index].entrevista.ausencia_entrevista
    );
    setIdAgendamento(inforagendamentos[index].entrevista.id_entrevista);
    setInforTutor(restutor);
    let resanimal: AnimalFoto[] = [];
    let fotos = convertToBase64(inforagendamentos[index].animal.foto?.data);

    resanimal.push({
      foto: fotos,
      raca: inforagendamentos[index].animal.raca,
      nome: inforagendamentos[index].animal.nome,
      sexo: inforagendamentos[index].animal.sexo,
    });
    setInforAnimal(resanimal);
  }

  useEffect(() => {
    getAgendamentos();
  }, []);

  return (
    <>
      <Menus />
      {role === "admin" ? (
        <Tables
          title={" ENTREVISTAS AGENDADAS"}
          header1={"Tutor"}
          header2={"Data"}
          header3={"Hora"}
          header4={"Local"}
          body={agendamentoResult}
          status={"3"}
          callback={openModal}
          tabelaAgendamentos="Tabela de agendamentos"
        />
      ) : (
        <>
          <Tables
            title={" ENTREVISTAS AGENDADAS"}
            header1={"Data"}
            header2={"Hora"}
            header3={"Local"}
            body={agendamentoTutorResult}
            status={"1"}
          />
        </>
      )}

      <Modal onClose={onClose} size={"3xl"} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            textAlign={"center"}
            mb={4}
            color={"#2F2E41"}
            fontSize={30}
          >
            Informações do Tutor
          </ModalHeader>
          <ModalBody>
            <StyleHStack>
              <FormControl>
                {inforTutor.map((item) => {
                  return (
                    <>
                      <InputGroup gap={5}>
                        <Text fontWeight={"bold"}>Nome:</Text>
                        <Text>{item.nome}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>CPF:</Text>
                        <Text>{item.cpf}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Rua:</Text>
                        <Text>{item.rua}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>N°:</Text>
                        <Text>{item.numero}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Bairro:</Text>
                        <Text>{item.bairro}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Cidade:</Text>
                        <Text>{item.cidade}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>UF:</Text>
                        <Text>{item.uf}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Email:</Text>
                        <Text>{item.email}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Whatsapp:</Text>
                        <Text>{item.whastapp}</Text>
                      </InputGroup>
                      <InputGroup gap={5} mt={3}>
                        <Text fontWeight={"bold"}>Instagram:</Text>
                        <Text>{item.instagram}</Text>
                      </InputGroup>
                    </>
                  );
                })}
              </FormControl>

              <FormControl>
                <StyledFormControl>
                  <StyledFormControlMarge>
                    <Text
                      textAlign={"center"}
                      fontSize={20}
                      fontWeight={"bold"}
                      color={"#2F2E41"}
                      mb={3}
                    >
                      Informações do animal a ser adotado
                    </Text>
                    {inforAnimal.map((item) => {
                      return (
                        <Card
                          direction={{ base: "column", sm: "row" }}
                          overflow="hidden"
                          variant="outline"
                        >
                          <Image
                            objectFit="cover"
                            maxW={{ base: "100%", sm: "220px" }}
                            src={`data:image/jpeg;base64,${item.foto}`}
                          />
                          <CardBody>
                            <InputGroup gap={2}>
                              <Text fontWeight={"bold"}>Nome:</Text>
                              <Text>{item.nome}</Text>
                            </InputGroup>
                            <InputGroup gap={4} mt={3}>
                              <Text fontWeight={"bold"}>Raça:</Text>
                              <Text>{item.raca}</Text>
                            </InputGroup>
                            <InputGroup gap={4} mt={3}>
                              <Text fontWeight={"bold"}>Sexo:</Text>
                              <Text>{item.sexo}</Text>
                            </InputGroup>
                          </CardBody>
                        </Card>
                      );
                    })}
                  </StyledFormControlMarge>
                  <FormControl mt={5}>
                    {inforTutor.map((item) => {
                      return (
                        <>
                          <InputGroup gap={4} mt={3}>
                            <Text fontWeight={"bold"}>
                              Tem experiência com animais?
                            </Text>
                            <Text>
                              {item.tem_experiencia === true ? "Sim" : "Não"}
                            </Text>
                          </InputGroup>
                          <InputGroup gap={4} mt={3}>
                            <Text fontWeight={"bold"}>
                              Tem outro animal em casa?
                            </Text>
                            <Text>{item.tem_outro_animal ? "Sim" : "Não"}</Text>
                          </InputGroup>
                          <InputGroup gap={4} mt={3}>
                            <Text fontWeight={"bold"}>Tipo do aminal:</Text>
                            <Text>
                              {item.tipo_animais.length > 2 ? (
                                <>
                                  {item.tipo_animais.map((item) => {
                                    return <>{item}, </>;
                                  })}
                                </>
                              ) : (
                                <>{item.tipo_animais}</>
                              )}
                            </Text>
                          </InputGroup>
                          <InputGroup gap={4} mt={3}>
                            <Text fontWeight={"bold"}>
                              Quantidade de animais em casa:
                            </Text>
                            <Text>{item.quantidade_animais}</Text>
                          </InputGroup>
                        </>
                      );
                    })}
                  </FormControl>
                </StyledFormControl>
              </FormControl>
            </StyleHStack>
          </ModalBody>
          <ModalFooter display={"flex"} justifyContent={"space-between"}>
            <form>
              <FormControl display="flex" alignItems="center">
                <FormLabel mb="0">Tutor compareceu à entrevista?</FormLabel>
                <Switch
                  colorScheme={"teal"}
                  defaultChecked={statusAgendamento}
                  onChange={(e) =>
                    updatebtnAgendamentos(e.target.checked, idAgendamento)
                  }
                />
              </FormControl>
            </form>
            <Button
              variant={"outline"}
              border={"1px solid #c03333"}
              color={"#c03333"}
              _hover={{ backgroundColor: "#c03333", color: "#ffffff" }}
              onClick={onClose}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export { Agendamentos };
